import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
//import User from "./components/User";
//import CreateUser from "./components/CreateUser";
//import UpdateUser from "./components/UpdateUser";
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import Container from "react-bootstrap/esm/Container";
import LandingPage from "./screens/LandingPage/LandingPage";
import Dashboard from "./screens/LandingPage/Dashboard";
import LoginScreen from "./screens/LoginScreen/LoginScreen";
import ChangePassword from "./screens/LoginScreen/ChangePassword";
import RegisterScreen from "./screens/RegisterScreen/RegisterScreen";
import RegisterContractor from "./screens/Contractor/RegisterContractor";
import ManageContractors from "./screens/Contractor/ManageContractors";
import ManageUSers from "./screens/User/ManageUsers";
import AssignRoles from "./screens/User/AssignRoles";
import ManageEmployees from "./screens/Employee/ManageEmployees";
import ManageAttendance from "./screens/AttendanceMuster/ManageAttendance";
import ManageShGrpAlloc from "./screens/Employee/ManageShGrpAlloc";

import PrintDailyAttendance from "./screens/AttendanceMuster/PrintDailyAttendance";
import PrintAttendanceFormat2 from "./screens/AttendanceMuster/PrintAttendanceFormat2";
import MonthlyAtndSheet from "./screens/AttendanceMuster/MonthlyAtndSheet";
import UpdDeptInMust from "./screens/AttendanceMuster/UpdDeptInMust";
import RegularizePunchGrid from "./screens/AttendanceMuster/RegularizePunchGrid.js";
import PrintAtndSummary from "./screens/AttendanceMuster/PrintAtndSummary";
import RegenerateMuster from "./screens/AttendanceMuster/RegenerateMuster";
import ManualProcessAttendance from "./screens/AttendanceMuster/ManualProcessAttendance";
import PrintApprovedVsPresent from "./screens/AttendanceMuster/PrintApprovedVsPresent";
import PrintApprVsPresentPeriod from "./screens/AttendanceMuster/PrintApprVsPresentPeriod";
import ApproveDailyAttendance from "./screens/AttendanceMuster/ApproveDailyAttendance";


import ExportEmpMastDump from "./screens/Employee/ExportEmpMastDump";
import ExportFixWagesDump from "./screens/Wages/ExportFixWagesDump";
import ProcessWages from "./screens/Wages/ProcessWages";
import ManageFixWages from "./screens/Wages/ManageFixWages";
import PrintWages from "./screens/Wages/PrintWages";
import WageDeductions from "./screens/Wages/AddWageDeductionsGrid";
import WageArraers from "./screens/Wages/AddWageArrearsGrid";
import WageSlip from "./screens/Wages/WageSlip";
import BankStatement from "./screens/Wages/ExportBankStatement";
import PFStatement from "./screens/Wages/ExportPFStatement";
import ESIStatement from "./screens/Wages/ExportESIStatement";
import CashStatement from "./screens/Wages/ExportCashStatement";

import ManageProcessMonth from "./screens/Wages/ManageProcessMonth";
import ManageWageProcessLock from "./screens/Wages/ManageWageProcessLock";
import MonthlyAtndRegTimes from "./screens/AttendanceMuster/MonthlyAtndRegTimes";
import ManualMuster from "./screens/AttendanceMuster/ManualMuster";
import EmpRequest from "./screens/AttendanceMuster/EmpRequest.js";
import ServiceCharges from "./screens/Wages/ManageServiceCharges";
import ExportWageComparission from "./screens/Wages/ExportWageComparission";
import InActiveEmp from "./screens/Employee/InActiveEmp";
import ResetSuccess from "./screens/LoginScreen/ResetSuccess.js";
import ResetPasswd from "./screens/LoginScreen/ResetPasswd.js";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Container>
          <Header />
          <main>
            <Routes>
              <Route path="/" Component={LandingPage} exact />
              <Route path="/Dashboard" Component={Dashboard} exact />
              <Route path="/login" Component={LoginScreen} exact />
              <Route path="/change-password" Component={ChangePassword} exact />
              <Route path="/register" Component={RegisterScreen} exact />
              <Route path="/registerContractor" Component={RegisterContractor} exact />
              <Route path="/manageContractors" Component={ManageContractors} exact />
              <Route path="/manageUsers" Component={ManageUSers} exact />
              <Route path="/AssignRoles" Component={AssignRoles} exact />
              <Route path="/manageEmployees" Component={ManageEmployees} exact />
              <Route path="/manageAttendance" Component={ManageAttendance} exact />              
              <Route path="/printDailyAttendance" Component={PrintDailyAttendance} exact />
              <Route path="/approveDailyAttendance" Component={ApproveDailyAttendance} exact />
              <Route path="/PrintAttendanceFormat2" Component={PrintAttendanceFormat2} exact />
              <Route path="/printAtndSummary" Component={PrintAtndSummary} exact />
              <Route path="/monthlyAtndSheet" Component={MonthlyAtndSheet} exact />
              <Route path="/updDeptInMust" Component={UpdDeptInMust} exact />
              <Route path="/manageShGrpAlloc" Component={ManageShGrpAlloc} exact />
              <Route path="/regularizePunches" Component={RegularizePunchGrid} exact />
              <Route path="/exportEmpMastDump" Component={ExportEmpMastDump} exact />
              <Route path="/processWages" Component={ProcessWages} exact />
              <Route path="/ExportFixWagesDump" Component={ExportFixWagesDump} exact />
              <Route path="/ManageFixWages" Component={ManageFixWages} exact />
              <Route path="/printWages" Component={PrintWages} exact />
              <Route path="/regenerateMuster" Component={RegenerateMuster} exact />
              <Route path="/wageDeductions" Component={WageDeductions} exact />
              <Route path="/wageArrears" Component={WageArraers} exact />
              <Route path="/manualProcessAttendance" Component={ManualProcessAttendance} exact />
              <Route path="/wageSlip" Component={WageSlip} exact />
              <Route path="/monthlyAtndRegTimes" Component={MonthlyAtndRegTimes} exact />
              <Route path="/getBankStatement" Component={BankStatement} exact />
              <Route path="/getPFStatement" Component={PFStatement} exact />
              <Route path="/getESIStatement" Component={ESIStatement} exact />
              <Route path="/getCashStatement" Component={CashStatement} exact />
              <Route path="/manageProcessMonth" Component={ManageProcessMonth} exact />
              <Route path="/manageWageProcessLock" Component={ManageWageProcessLock} exact />
              <Route path="/ManualMuster" Component={ManualMuster} exact />
              <Route path="/EmpRequest" Component={EmpRequest} exact />          
              <Route path="/printApprovedVsPresent" Component={PrintApprovedVsPresent} exact />          
              <Route path="/ServiceCharges" Component={ServiceCharges} exact />          
              <Route path="/ExportWageComparission" Component={ExportWageComparission} exact />          
              <Route path="/printApprVsPresentPeriod" Component={PrintApprVsPresentPeriod} exact />          
              <Route path="/InActiveEmp" Component={InActiveEmp} exact />
              <Route path="/resetSuccess" element={<ResetSuccess />} />
              <Route path="/resetPassword" element={<ResetPasswd />} />
            </Routes>
          </main>
          <Footer />
        </Container>
      </BrowserRouter>
    </div>
  );
}

export default App;
